import React, { useState } from "react";
import { Grid, TextField } from "@mui/material";
import moment from "moment/moment";

import { getToken } from "../../../../api/Account";
import { updateVacacionesAsync } from "../../../../api/Employees";
import { useAviso } from "../../../../components/base";
import { CampoFecha, DialogoFormulario, useEnvio, useEscritura } from "../comunes";

const UpdateVacaciones = ({ selected, setShowModal, reload, setReload }) => {
  const [motivo, setMotivo] = useState(selected.motivo);
  const [desde, setDesde] = useState(new Date(selected.desde));
  const [hasta, setHasta] = useState(new Date(selected.hasta));
  const [intentado, setIntentado] = useState(false);

  const token = getToken();
  const aviso = useAviso();
  const escribir = useEscritura();
  const { guardando, enviar } = useEnvio();

  // Las reglas de siempre: motivo vacío y fechas válidas.
  const errores = {};
  if (motivo.length === 0) errores.motivo = "Ingrese un motivo";
  if (!moment(desde).isValid()) errores.desde = "Seleccione una fecha válida";
  if (!moment(hasta).isValid()) errores.hasta = "Seleccione una fecha válida";

  const saveChanges = () =>
    enviar(async () => {
      setIntentado(true);
      if (Object.keys(errores).length > 0) return;

      const data = {
        id: selected.id,
        motivo,
        desde: moment(desde).format("YYYY-MM-DD"),
        hasta: moment(hasta).format("YYYY-MM-DD"),
      };

      const ok = await escribir(
        () => updateVacacionesAsync(token, data),
        "No se pudieron editar las vacaciones"
      );
      if (!ok) return;
      aviso.exito("Vacaciones editadas");
      setReload(!reload);
      setShowModal(false);
    });

  const mostrar = intentado ? errores : {};
  const hayCambios =
    motivo !== selected.motivo ||
    !moment(desde).isSame(moment(selected.desde), "day") ||
    !moment(hasta).isSame(moment(selected.hasta), "day");

  return (
    <DialogoFormulario
      titulo={`Editar vacaciones #${selected.id}`}
      onCerrar={() => setShowModal(false)}
      hayCambios={hayCambios}
      guardando={guardando}
      onEnviar={saveChanges}
      textoEnviar="Guardar cambios"
    >
      <Grid container spacing={2} sx={{ pt: 1 }}>
        <Grid item xs={12}>
          <TextField
            autoFocus
            required
            fullWidth
            label="Descripción"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value.toUpperCase())}
            error={Boolean(mostrar.motivo)}
            helperText={mostrar.motivo || " "}
            disabled={guardando}
            inputProps={{ autoComplete: "off" }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CampoFecha
            label="Inicio"
            value={desde}
            onChange={(newValue) => setDesde(newValue)}
            error={mostrar.desde}
            disabled={guardando}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CampoFecha
            label="Retorno"
            value={hasta}
            onChange={(newValue) => setHasta(newValue)}
            error={mostrar.hasta}
            disabled={guardando}
          />
        </Grid>
      </Grid>
    </DialogoFormulario>
  );
};

export default UpdateVacaciones;
